<template>
    <div>
        <ag-grid-vue :style="{ height: heightInside }" style="width: 100%;"
            class="ag-theme-balham center-box elevation-2 taskValidationGrid" :columnDefs="columnDefs"
            :rowData="rowData" :gridOptions="gridOptions" :rowSelection="rowSelection" :enableCellChangeFlash="true"
            @selection-changed="onSelectionChanged" @grid-ready="onGridReady" pagination=true
            :overlayNoRowsTemplate="overlayNoRowsTemplate" />
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { clientEventService } from '../services/client.event.service';
import { dateService } from "../services/date.service";
import { STORE_CONSTANTS } from "@/common/store.constants.js";

const NOTIFY_STORAGE_KEY = "eventNotifyLog";

export default {
    name: "EventAgregateTable",
    components: {
        AgGridVue,
    },
    props: {
        eventsData: Array,
        view: String,
        heightInside: String,
        isExporting: Boolean,
        study: String,
    },
    data() {
        return {
            STORE_CONSTANTS,
            columnDefs: [],
            rowData: [],
            rowSelection: "single",
            gridOptions: {},
            gridApi: null,
            gridColumnApi: null,
            overlayNoRowsTemplate: null,
            notifiedMap: {},
        };
    },
    computed: {
        dataGrid() {
            return this.eventsData;
        },
    },
    watch: {
        dataGrid(newValue, oldValue) {
            if (newValue !== oldValue && this.gridApi) {
                console.log("Event data updated: ", newValue);
                this.gridApi.setRowData(newValue);
            }
        },
        isExporting(newVal) {
            if (newVal === true && this.gridApi) {
                const data = this.gridApi.getDataAsCsv();
                this.$emit("rowsExported", { data });
            }
        },
        view(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loadColumnDefs(newVal);
            }
        },
    },
    created() {
        this.overlayNoRowsTemplate =
            '<span style="padding: 10px; border: 2px solid #2b7588; background: #e0e0e0; font-size: 14px">No events found for the selected criteria.</span>';
        this.notifiedMap = this.loadNotifiedMap();
    },
    mounted() {
        this.loadColumnDefs(this.view);
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
        if (this.tracksData && this.tracksData.length > 0) {
            this.rowData = this.tracksData;
        }
        window.addEventListener("resize", this.onResize);
    },
    beforeUnmount() {
        if (this.gridApi) {
            this.gridApi.destroy();
        }
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        getTracksForDay(myCriteria) {
            console.log("getTracksForDay in Track table");
            console.log("getTracksForDay myCriteria: ", myCriteria);

            const me = this;
            const rangeStart = dateService.getDateTime(myCriteria.date);
            const rangeEnd = myCriteria.date;

            // const staff =
            //     me.$store.getters["study/getSelectedStudyStaffMap"][myCriteria.staffId];
            // if (staff) {
            //     me.staffFullName = `${staff.nameFirst} ${staff.nameLast}`;
            // }

            const criteria = {
                study: me.study,
                staffId: myCriteria.staffId,
                dateStart: rangeStart,
                dateEnd: rangeEnd,
            };
            console.log("getTracksForDay criteria: ", criteria);

            me.$store.commit(
                me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING,
                true
            );

            me.$store
                .dispatch(
                    me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE.GET_TRACKS_AND_CLUSTERS_FOR_DAY,
                    criteria
                )
                .then((results) => {
                    if (!results.tracks) {
                        me.$store.commit(
                            me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING,
                            false
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    me.$store.commit(
                        me.STORE_CONSTANTS.VALIDATION.MUTATIONS.WITH_NAMESPACE.SET_IS_LOADING,
                        false
                    );
                });
        },
        loadColumnDefs(view) {
            this.columnDefs = [
                {
                    headerName: "Date",
                    field: "date",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    cellStyle: { display: 'flex', fontSize: '16px' },
                },
                {
                    headerName: "Staff Name",
                    field: "staffName",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    cellStyle: { display: 'flex', fontSize: '16px' },
                },
                {
                    headerName: "Staff ID",
                    field: "staffId",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    cellStyle: { display: 'flex', fontSize: '16px' },
                },
                {
                    headerName: "Fatal Event Count",
                    field: "fatalEventCount",
                    sortable: true,
                    filter: true,
                    resizable: true,
                    maxWidth: 200,
                    cellStyle: { display: 'flex', fontSize: '16px' },
                    cellClass: params => {
                        return params.value > 0 ? "bg-danger text-white" : "";
                    },
                },
                {
                    headerName: "Notify",
                    colId: "notify",
                    sortable: true,
                    filter: true,
                    valueGetter: params => {
                        if (!(params.data?.fatalEventCount > 0)) return "";
                        return this.notifiedMap[this.notifyKey(params.data)] ? "Notified" : "Not notified";
                    },
                    comparator: (a, b) => {
                        const rank = { "Not notified": 0, "Notified": 1, "": 2 };
                        return rank[a] - rank[b];
                    },
                    resizable: true,
                    cellRenderer: params => {
                        if (!(params.data?.fatalEventCount > 0)) return '';

                        const notifiedAt = this.notifiedMap[this.notifyKey(params.data)];
                        const linkStyle = "color:#007bff; font-size:16px; text-decoration:underline; cursor:pointer;";

                        if (notifiedAt) {
                            const when = new Date(notifiedAt).toLocaleString();
                            return `<span style="color:#198754; font-size:16px; margin-right:12px;" title="${when}">✓ Notified</span>
                    <span class="clickable-email" style="${linkStyle}">Notify again</span>`;
                        }
                        return `<span class="clickable-email" style="${linkStyle}">Click to Notify</span>`;
                    },
                    onCellClicked: params => {
                        if (params.data?.fatalEventCount > 0) {
                            this.handleNotifyClick(params.data, params.node);
                        }
                    },
                    cellStyle: params => {
                        if (params.data?.fatalEventCount > 0) {
                            return { display: 'flex', alignItems: 'center', cursor: 'pointer' };
                        }
                        return { display: 'flex', color: 'gray', cursor: 'default' };
                    },
                },

            ];
        },
        onSelectionChanged(event) {
            const selectedRows = event.api.getSelectedRows();
            this.getTracksForDay(selectedRows[0]);
            this.$emit("updateTrackSummaryCriteria", selectedRows);
        },
        onGridReady(params) {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            if (this.dataGrid && this.dataGrid.length > 0) {
                this.gridApi.setRowData(this.dataGrid);
            } else {
                this.gridApi.setRowData([]);
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.gridApi.sizeColumnsToFit();
                }, 50);
            });
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            return new Date(dateStr).toLocaleString();
        },
        onResize() {
            if (this.gridApi) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        handleNotifyClick(rowData, rowNode) {
            const alreadyNotified = !!this.notifiedMap[this.notifyKey(rowData)];
            if (alreadyNotified && !window.confirm(`Notify ${rowData.staffName || rowData.staffId} again?`)) {
                return;
            }

            const criteria = {
                study: this.study,
                staffId: rowData.staffId,
            };

            clientEventService.notifyClientEventsReport(criteria, rowData)
                .then(response => {
                    console.log("Notification sent:", response.data);
                    if (response.data === true) {
                        this.saveNotified(rowData);
                        this.gridApi.refreshCells({
                            rowNodes: rowNode ? [rowNode] : undefined,
                            columns: ["notify"],
                            force: true,
                        });
                        this.gridApi.onSortChanged();
                        this.gridApi.onFilterChanged();
                    }
                })
                .catch(error => {
                    console.error("Notification error:", error);
                });
        },
        notifyKey(row) {
            return `${this.study}|${row.staffId}|${row.date}`;
        },
        loadNotifiedMap() {
            try {
                return JSON.parse(localStorage.getItem(NOTIFY_STORAGE_KEY)) || {};
            } catch (e) {
                return {};
            }
        },
        saveNotified(row) {
            this.notifiedMap = {
                ...this.notifiedMap,
                [this.notifyKey(row)]: new Date().toISOString(),
            };
            try {
                localStorage.setItem(NOTIFY_STORAGE_KEY, JSON.stringify(this.notifiedMap));
            } catch (e) {
                console.warn("Could not save notify log", e);
            }
        },
    },

};
</script>

<style scoped>
::v-deep(.ag-theme-balham .ag-header-cell-text) {
    font-size: 17px !important;
    font-weight: 600;
}
</style>